import { useEffect } from "react";

import { useQueryItemsByIds } from "@/components/BacklogTable/hooks";
import LoadingPage from "@/components/LoadingPage";
import type { Item } from "@/types/common";

interface CloneItemsProviderChildrenArgs {
  items: Item[];
}

interface CloneItemsProviderProps {
  selectedItems: string[];
  children: (args: CloneItemsProviderChildrenArgs) => React.ReactElement;
}

export function CloneItemsProvider({ selectedItems, children }: CloneItemsProviderProps) {
  const { loading, items, hasMore, loadNextPage } = useQueryItemsByIds(selectedItems);

  useEffect(() => {
    if (hasMore && !loading) {
      loadNextPage();
    }
  }, [hasMore, loadNextPage, loading]);

  if (loading || hasMore) {
    return <LoadingPage label={`Loading items... ${items.length}/${selectedItems.length}`} />;
  }
  return children({ items });
}
